import React from "react";
import { Link, useLocation } from "@reach/router";

export default function NavBar() {
  const location = useLocation();
  const telas = [
    { title: "Home", path: "/" },
    { title: "Usuários", path: "/users" },
    { title: "Tipos de Bebida", path: "/drinks" },
    { title: "Estilos", path: "/styles" },
    { title: "Categorias", path: "/categories" },
    { title: "Atributos", path: "/attributes" },
    { title: "Características (aroma, sabor, etc)", path: "/traits" },
  ];
  return (
    <div className="flex flex-col w-64 pt-32 h-screen bg-background absolute top-0 z-[-1] overflow-y-scroll">
      {telas.map((l, i) => (
        <Link
          key={"knb" + i}
          className={`h-8 py-2 font-bold text-base pl-12 border-l-2 mb-5 ${
            location.pathname === l.path
              ? "text-white border-primary"
              : "text-[#ccc] border-background"
          }`}
          to={l.path}
        >
          {l.title}
        </Link>
      ))}
    </div>
  );
}
